/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Tweens.Builders
 */

module.exports = {

    GetBoolean: require('./GetBoolean'),
    GetEaseFunction: require('./GetEaseFunction'),
    GetNewValue: require('./GetNewValue'),
    GetProps: require('./GetProps'),
    GetTargets: require('./GetTargets'),
    GetTweens: require('./GetTweens'),
    GetValueOp: require('./GetValueOp'),
    NumberTweenBuilder: require('./NumberTweenBuilder'),
    TimelineBuilder: require('./TimelineBuilder'),
    TweenBuilder: require('./TweenBuilder')

};



//////////////////
// WEBPACK FOOTER
// ./tweens/builders/index.js
// module id = 974
// module chunks = 0